import Link from 'next/link';
import Image from 'next/image';
import {defaultThemeImagePaths, priceHelper} from '@helpers/config-master.mjs';
import {JsonLdBreadcrumbList} from '@components/json-ld/breadcrumb-list';
import {insertMenuItemsBeforeId} from '@components/collections/ManuallyInjectSpecificCollections';

export const DesktopCollectionPageComponent = ({slug, title, description, collections}) => {
  // const desktopHeaderImage = useDesktopCollectionHeaderImage();
  const desktopHeaderImage = defaultThemeImagePaths?.desktopCollectionPageHeaderImage;

  const saleIsEnabled = priceHelper.saleEnabled;

  let updatedCollections = insertMenuItemsBeforeId([...collections]); // Create a new array

  return (
    <>
      {saleIsEnabled && (
        <div className="m-auto pb-3">
          {desktopHeaderImage && (
            <Image
              src={desktopHeaderImage}
              alt="desktop banner"
              width="1200"
              height="160"
              priority
            />
          )}
        </div>
      )}
      <CollectionHeaderDesktop title={title} description={description} />

      <div>
        <div className="grid grid-cols-3 gap-6 mb-16 mt-8">
          {updatedCollections?.map((item, index) => {
            const {
              sku,
              title: itemTitle,
              subtitle: itemSubtitle,
              id,
              slug: itemSlug,
              imageUrl
            } = item || {};

            return (
              <div key={`${id}-${index}`}>
                <Link href={encodeURI(itemSlug)}>
                  <div className="overflow-hidden relative rounded group">
                    <div
                      className="z-10 group-hover:opacity-100 transition duration-300 ease-in-out
                   cursor-pointer absolute from-black/80 to-transparent bg-gradient-to-t inset-x-0
                    -bottom-2 pt-30 text-white flex items-end w-full">
                      <div
                        className="uppercase font-oswald text-white transform-gpu p-4 pt-[80px]
                    group-hover:translate-y-0 translate-y-1 pb-6 transition duration-700 ease-out">
                        <h2 className="text-xl mt-1 mb-0">{itemTitle ?? sku}</h2>
                        {itemSubtitle && <h3 className=" text-md mt-0 mb-0">{itemSubtitle}</h3>}
                      </div>
                    </div>

                    <div className="group-hover:scale-105 transition duration-700 ease-in-out">
                      {imageUrl ? (
                        <Image
                          className="rounded object-cover w-full"
                          src={imageUrl}
                          alt={`Category image for ${itemTitle}`}
                          width={400}
                          height={400}
                          sizes="(min-width: 1024px) 417px, 45vw"
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      <JsonLdBreadcrumbList handle={`/collections/${slug}`} title={title} />
    </>
  );
};

export const CollectionHeaderDesktop = ({title, subtitle, description}) => {
  // console.log("[CollectionHeaderDesktop] title", title, subtitle)
  return (
    <div className="px-3 font-oswald font-medium uppercase text-black mb-2">
      <h1 className="text-5xl">{title}</h1>
      {subtitle && <h2 className="text-2xl mt-2">{subtitle}</h2>}
      {description && <p className="sr-only">{description}</p>}

      <div
        style={{
          background: 'linear-gradient(90deg, #26292B 52.96%, rgba(50, 54, 58, 0) 90.63%)',
          height: 2,
          width: '100%'
        }}
      />
    </div>
  );
};
